import { render, staticRenderFns } from "./browsingHistory.vue?vue&type=template&id=138d07c9&scoped=true"
import script from "./browsingHistory.vue?vue&type=script&lang=js"
export * from "./browsingHistory.vue?vue&type=script&lang=js"
import style0 from "./browsingHistory.vue?vue&type=style&index=0&id=138d07c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d07c9",
  null
  
)

export default component.exports